import React, { useState, useEffect, useRef } from "react";
import { DefaultRefreshIcon, PullIndicator, RefreshContainer } from "./RefreshComponents";
// import "./App.css";

let refreshContainer = { scrollTop: null };
let pullIndicator = null;
let startY = 0;
let currentY = null;
let isPulling = false;

function PullToRefresh({
  dragHeight = 120,
  refreshIcon = <DefaultRefreshIcon/>,
  refreshing = false,
  onRefresh = () => console.log("onRefresh"),
  children = <></>,
}) {
  
  const [isPull, setIsPull] = useState(false)
  // const [refresh, setRefreshing] = useState(false)

  useEffect(() => {
    if (refreshing === false) {
      let _pullIndicator = document.getElementById("pull-indicator");
      _pullIndicator.style.display = "none";
      // _pullIndicator.innerText = "↓ Pull to refresh";
    }

  }, [refreshing])

  return (
    <RefreshContainer
      id="refresh-container"
      onTouchStart={(e) => {
        refreshContainer.scrollTop = window.scrollY;
        if (refreshContainer.scrollTop === 0) {
          console.log("🚀 ~ touchstart refreshContainer.scrollTop:",refreshContainer.scrollTop);
          console.log("🚀 ~ touchstart e.touches[0].pageY:",e.touches[0].pageY);
          startY = e.touches[0].pageY;
          isPulling = true;
        }
      }}

      onTouchMove={(e) => {
        pullIndicator = document.getElementById("pull-indicator");
        // จังหวะกดค้าง
        if (isPulling) {
          // อยู่บนสุด
          currentY = e.touches[0].pageY; // ตำแหน่งลากปัจจุบัน (ตอนมือกดค้างไว้)
          // console.log("🚀 ~ touchmove startY:", startY);
          // console.log("🚀 ~ touchmove currentY:", currentY);
          if (currentY > (startY + 100)) {
            if (refreshing === false ) {
              pullIndicator.style.display = "block";
            }
          } else {
            pullIndicator.style.display = "none";
          }
        }
      }}

      onTouchEnd={(e) => {

        pullIndicator = document.getElementById("pull-indicator");
        // console.log("touchend changedTouches >>", e.changedTouches[0].pageY);
        // console.log("touchend isPulling >>", isPulling);
        if (isPulling) {
          // อยู่บนสุด
          let endY = e.changedTouches[0].pageY; // ตำแหน่งลากปัจจุบัน (ตอนมือกดปล่อย)
          // console.log("🚀 ~ endY:", endY)
          // console.log("🚀 ~ startY + dragHeight:", startY + dragHeight)
          if (endY > (startY + dragHeight)) {
            // ลากจุดสุดท้าย มากกว่า จุดเริ่ม + 50 รึเปล่า
            // Trigger refresh
            // pullIndicator.innerText = "Refreshing...";
            pullIndicator.style.display = "none";

            onRefresh()
            console.log('isPULLL SS')

            // setTimeout(function () {
            //   pullIndicator.style.display = "none";
            //   pullIndicator.innerText = "↓ Pull to refresh";
            // }, 2000); // Simulate refresh time
          } else {
            console.log('isPULLL LOST')

            pullIndicator.style.display = "none";
          }
          isPulling = false;
        }
      }}
    >
      <PullIndicator/>
      { refreshing ? refreshIcon : <></>}
      
      <div id="content">{children}</div>
    </RefreshContainer>
  );
}

export default PullToRefresh;


